<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-2 col-12">
                <div class="form-group">
                    <label for="activeSelect">Active</label>
                    <select id="activeSelect" class="form-select" [(ngModel)]="target.active" name="active">
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-2 col-12">
                <div class="form-group">
                    <label for="txbxSignIn">Sign In</label>
                    <input id="txbxSignIn" type="text" class="form-control" [(ngModel)]="target.name" name="name" disabled />
                </div>
            </div>
            <div class="col-sm-2 col-12">
                <div class="form-group">
                    <label for="txbxHrRef">HR Ref</label>
                    <input id="txbxHrRef" type="number" class="form-control" [(ngModel)]="target.hrRef" name="hrRef" />
                </div>
            </div>
            <div class="col-sm-2 col-12">
                <div class="form-group">
                    <label for="vendorId">Vendor #</label>
                    <input id="vendorId" type="number" class="form-control" [(ngModel)]="target.vendorId" name="vendorId" />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="txbxEmailAddress">Email Address</label>
                    <input id="txbxEmailAddress" type="text" class="form-control" [(ngModel)]="target.emailAddress" name="emailAddress" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2 col-12">
                <div class="form-group">
                    <label for="requireAuthenticatorMfaSelect">Require MFA</label>
                    <select
                        id="requireAuthenticatorMfaSelect"
                        class="form-select"
                        [(ngModel)]="target.requireAuthenticatorMfa"
                        name="requireAuthenticatorMfa"
                        [disabled]="target.isLessor"
                    >
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                    </select>
                    @if (target.twoFactorEnabled) {
                        <div class="form-text">Enrolled</div>
                    }
                    @if (target.isLessor) {
                        <div class="form-text">Lessors are not required to use MFA.</div>
                    }
                    @if (target.isHighRisk && !target.requireAuthenticatorMfa && !target.isLessor) {
                        <div class="form-text">Suggested: this user has high-risk rights.</div>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-12">
                <div class="form-group">
                    <label for="rolesSelector">Available Roles</label>
                    <wj-list-box
                        #rolesSelector
                        id="rolesSelector"
                        class="form-control"
                        style="height: 300px; padding: 0"
                        [itemsSource]="roles"
                        [displayMemberPath]="'name'"
                        [checkedMemberPath]="'checked'"
                    ></wj-list-box>
                </div>
            </div>
            <div class="col-md-4 col-12">
                <div class="form-group">
                    <label for="rightsSelector">Available Additional Rights</label>
                    <wj-list-box
                        #rightsSelector
                        id="rightsSelector"
                        class="form-control"
                        style="height: 300px; padding: 0"
                        [itemsSource]="rights"
                        [displayMemberPath]="'name'"
                        [checkedMemberPath]="'checked'"
                    ></wj-list-box>
                </div>
            </div>
            <div class="col-md-4 col-12">
                <div class="form-group" style="display: flex; flex-direction: column">
                    <div
                        [hidden]="target.imageUrl"
                        style="
                            display: flex;
                            height: 276px;
                            border: 1px solid lightgray;
                            border-radius: 5px;
                            align-items: center;
                            justify-content: center;
                            margin-bottom: 10px;
                            color: #9f9b9b;
                            font-size: 20px;
                        "
                    >
                        No Image
                    </div>
                    <img style="max-width: 100%; margin-bottom: 10px" [src]="target.imageUrl" [hidden]="!target.imageUrl" />
                    <button type="button" class="btn btn-secondary" (click)="fileInput.click()">Upload Image</button>
                    <input #fileInput style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
